import React from 'react';

import { Props } from './Page.types';
import { Styled } from './Page.styles';
import { PageHeader } from '../PageHeader';

export const Page: React.FC<Props> = ({ children, ...props }) => (
  <Styled.Page>
    <PageHeader {...props} />
    {children}
  </Styled.Page>
);
